class QuantityUrlSync extends HTMLElement {
  constructor() {
    super();
    this.queryParam = this.getAttribute('query-param') || 'quantity';
    this.radioInputs = this.querySelectorAll('input[type="radio"][name="quantity"]');
    this.mainQuantityInput = this.querySelector('input.quantity__input[name="quantity"]');

    if (this.radioInputs.length === 0) {
      console.warn('QuantityUrlSync: No radio inputs with name="quantity" found.');
      return;
    }

    this.initialSelect();
    this.addEventListeners();
  }

  /**
   * Reads the URL parameter and checks the corresponding radio input.
   * Also handles the custom quantity field for the 'I want more' option.
   */
  initialSelect() {
    const urlParams = new URLSearchParams(window.location.search);
    let urlValue = urlParams.get(this.queryParam);

    // --- ADDED LOGIC FOR DEFAULT VALUE ---
    // If the URL has no parameter OR the parameter is empty
    if (!urlValue) {
      // Set the default value to '1' (assuming 30 sachets is value="1")
      // Get the value from the first radio to comply with the DOM
      const defaultRadio = this.radioInputs[0];
      if (defaultRadio) urlValue = defaultRadio.value;
    }

    if (urlValue) {
      const targetRadio = Array.from(this.radioInputs).find(
        (input) => input.value === urlValue
      );

      if (targetRadio) {
        // Check the radio input
        targetRadio.checked = true;
        
        // Special handling for the "I want more" option (if it has a different activation mechanism)
        // We assume that if targetRadio is the 'I want more' radio (e.g., value="4"),
        // other elements might need to be revealed.
        if (targetRadio.id.endsWith('-4')) {
          const showMoreButton = this.querySelector('.v-option__label-more');
          const lastLabel = this.querySelector('.v-option__label--quantity-last');
          
          if (showMoreButton && lastLabel && !lastLabel.classList.contains('hidden')) {
             // The "I want more" option is already active/visible
          } else if (showMoreButton && lastLabel) {
            // Simulating a click on 'I want more'
            lastLabel.classList.remove('hidden');
            showMoreButton.classList.add('v-option__label-more--active');
            
            // If the URL value is different from the default value of the quantity input in the "I want more" section, set it.
            if (this.mainQuantityInput && this.mainQuantityInput.value !== urlValue) {
               this.mainQuantityInput.value = urlValue;
            }
          }
        }
      } else if (this.mainQuantityInput && parseInt(urlValue) >= parseInt(this.mainQuantityInput.dataset.min)) {
         // Handling the case where the URL has a value > 3 (e.g., 5) and "I want more" needs to be activated
         const radioForMore = this.querySelector('input[type="radio"][data-quantity-index="4"]'); // radio for min=4

         if (radioForMore) {
             radioForMore.checked = true;
             
             const showMoreButton = this.querySelector('.v-option__label-more');
             const lastLabel = this.querySelector('.v-option__label--quantity-last');
             
             if (showMoreButton && lastLabel) {
                 lastLabel.classList.remove('hidden');
                 showMoreButton.classList.add('v-option__label-more--active');
              }
              
              this.mainQuantityInput.value = urlValue;
              
              const quantityInputComponent = radioForMore.closest('.v-option__label-content').querySelector('quantity-input');
              quantityInputComponent?.validateQtyRules();
              console.log(quantityInputComponent);
         }
      }
    }
  }

  /**
   * Adds event listeners to radio inputs and the main quantity field.
   */
  addEventListeners() {
    // Listener for standard radio inputs
    this.radioInputs.forEach((input) => {
      input.addEventListener('change', this.handleInputChange.bind(this));
    });

    // Listener for the main quantity input in the "I want more" section (when it changes, e.g., from 4 to 5)
    if (this.mainQuantityInput) {
       this.mainQuantityInput.addEventListener('change', this.handleMainQuantityChange.bind(this));
       
       // Listeners for plus/minus buttons that change mainQuantityInput
       const quantityInputContainer = this.mainQuantityInput.closest('quantity-input');
       if (quantityInputContainer) {
          quantityInputContainer.querySelectorAll('.quantity__button').forEach((button) => {
             button.addEventListener('click', this.handleMainQuantityChange.bind(this));
          });
       }
    }
  }

  /**
   * Updates the URL after the selected radio changes.
   * @param {Event} event - The 'change' event on the radio input.
   */
  handleInputChange(event) {
    if (event.target.checked) {
      this.updateUrl(event.target.value);
    }
  }
  
  /**
   * Updates the URL after the value in the quantity field changes (for "I want more").
   */
  handleMainQuantityChange(e) {
      console.log('handleMainQuantityChange', e);
     // Check if the radio for this option is checked
     const radioForMore = this.querySelector('input[type="radio"][data-quantity-index="4"]');
     console.log(radioForMore);
     // Update the URL only if this option is active (e.g., value="4" is checked)
     if (radioForMore && radioForMore.checked) {
         this.updateUrl(this.mainQuantityInput.value);
     }
  }

  /**
   * Updates the URL parameter without reloading the page.
   * @param {string} value - The new parameter value.
   */
  updateUrl(value) {
    const url = new URL(window.location.href);
    
    // If the value is the same as the default radio value (e.g., '1' for 30 sachets), 
    // we can remove the parameter for a cleaner URL.
    const defaultValue = this.radioInputs.length > 0 ? this.radioInputs[0].value : null;

    if (value && value !== defaultValue) {
      url.searchParams.set(this.queryParam, value);
    } else {
      url.searchParams.delete(this.queryParam);
    }

    // Use history.replaceState to change the URL without reloading the page
    window.history.replaceState({}, '', url.toString());
  }
}

// Register the web component
if (!customElements.get('quantity-url-sync')) {
  customElements.define('quantity-url-sync', QuantityUrlSync);
}